module.exports = __webpack_public_path__ + "static/media/customer1.f6f05af4.svg";